<template>
  <div>
    <div class="md-layout separete-content slide-right">
      <div class="md-layout-item">
        <md-content class="page-content">
          <md-content
            class="center-content"
            :class="[
              { 'center-content-back': forgotAction === true },
              { 'md-elevation-5': animationHighlight },
            ]"
          >
            <div class="login-content">
              <SLoginForm
                @forgot="forgot"
                @emailTaken="emailTakenModal"
                class="login-form"
                v-if="!forgotAction"
                :title="title"
                :redirectTo="redirectTo"
              />
              <SRecoverForm
                ref="recoverForm"
                @forgot-username="showModal('username')"
                @forgot-password="showModal('password')"
                class="login-form"
                v-else
              />
            </div>
          </md-content>
        </md-content>
      </div>
      <div class="md-layout-item">
        <div
          class="go-back-content"
          :class="{ 'go-back-action': forgotAction }"
        >
          <p v-if="!forgotAction">Don't have an account?&nbsp;</p>
          <a @click="backAction" data-cy="registrationButton">{{
            backButtonText
          }}</a>
        </div>
      </div>
    </div>
    <ModalForgot
      :isForgotPassword="isForgotPassword"
      :isForgotUsername="isForgotUsername"
      @forgotPassword="resendPassword"
      @forgotUsername="resendUsername"
    />
    <ModalActivation :activationResendObj="activationResendObj" />
  </div>
</template>

<script>
import SLoginForm from "@/material-components/molecules/SLoginForm.vue";
import SRecoverForm from "@/material-components/molecules/SRecoverForm.vue";
import UserHelperVue from "@/mixins/UserHelper.vue";
import ModalForgot from "@/components/molecules/ModalForgot.vue";
import ModalActivation from "@/components/molecules/ModalActivation.vue";
export default {
  name: "SLoginCard",
  mixins: [UserHelperVue],
  props: ["title", "redirectTo"],
  components: {
    SLoginForm,
    SRecoverForm,
    ModalForgot,
    ModalActivation,
  },
  data() {
    return {
      backButtonText: "Register",
      forgotAction: false,
      isForgotUsername: false,
      isForgotPassword: false,
      activationResendObj: {},
      animationHighlight: false,
    };
  },
  methods: {
    emailTakenModal(objResend) {
      this.activationResendObj = { ...objResend };
      this.activationResend = true;
    },
    forgot() {
      this.forgotAction = true;
      this.backButtonText = "< Go back";
    },
    resendPassword() {
      this.$refs.recoverForm.$refs.forgotPassword.submit();
    },
    resendUsername() {
      this.$refs.recoverForm.$refs.forgotUsername.submit();
    },
    backAction() {
      if (this.forgotAction) {
        if (
          this.$refs.recoverForm.passwordForm ||
          this.$refs.recoverForm.usernameForm
        ) {
          this.$refs.recoverForm.backToOptions();
        } else {
          this.forgotAction = false;
          this.backButtonText = "Register";
        }
      } else
        this.$router.push({
          path: "/signup",
          query: { redirect: this.redirectTo },
        });
    },
    showModal(type) {
      if (type === "password") {
        this.isForgotPassword = true;
        this.isForgotUsername = false;
      } else if (type === "username") {
        this.isForgotUsername = true;
        this.isForgotPassword = false;
      }
      $("#forgot").modal("show");
    },
  },
  mounted() {
    setTimeout(() => {
      this.animationHighlight = true;
    }, 201);
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  height: 22.125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: $light;
}
.center-content {
  width: 29.67rem;
  height: 22rem;
  margin-bottom: 12em;
  background: $white;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  transition: all 0.86s ease;
  /* transform: scale(0.1, 0.1); */
}
.md-elevation-5 {
  transform: scale(1, 1);
}
.login-form {
  width: 85%;
  transform: translateX(8.2%);
}
.go-back-content {
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 1.25px;
  width: 100%;
  display: inline-flex;
  justify-content: center;
}
.go-back-content p {
  font-size: 14px;
  color: #8d8c8c !important;
}
.go-back-content a {
  color: $request !important;
  text-decoration: none !important;
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.separete-content {
  display: flex;
  flex-wrap: nowrap;
  margin: auto;
  margin-top: 60px;
  flex-direction: column !important;
}
@media screen and (max-width: 425px) {
  .center-content {
    width: 90vw;
  }
}
@media screen and (min-width: 1024px) {
  .go-back-content {
    margin-top: 0;
  }
}
@media screen and (min-width: 1199px) {
  .center-content {
    height: 22rem;
  }
}
</style>

<style lang="scss" scoped>
.the-email-resend {
  color: $primary;
}
.resend-email-link {
  text-decoration: none !important;
  cursor: pointer;
  color: $primary;
}
.center-content-back {
  height: 20rem;
  margin-top: -20px;
}
</style>

<style lang="scss" scoped>
/* Animations */
.slide-right {
  -webkit-animation: slide-right 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: slide-right 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@-webkit-keyframes slide-right {
  0% {
    -webkit-transform: translateX(-2000px);
    transform: translateX(-2000px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
@keyframes slide-right {
  0% {
    -webkit-transform: translateX(-2000px);
    transform: translateX(-2000px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
</style>
